import Konva from 'konva';
import { ShapeTextOptions } from '../../../types';
import TextConfig = Konva.TextConfig;
import { DEFAULT_FONT_FAMILY } from '../defines';

export interface GetTextPropsOptions {
  defaultTextColor?: string;
  defaultFontFamily?: string;
  defaultFontSize?: number;
  defaultTextAlign?: 'center' | 'left' | 'right';
}

export const getTextProps = (
  shapeProps: Partial<ShapeTextOptions>,
  options?: GetTextPropsOptions
): TextConfig => {
  return {
    fontSize: shapeProps.fontSize || options?.defaultFontSize || 20,
    fontFamily:
      shapeProps.fontFamily ||
      options?.defaultFontFamily ||
      String(DEFAULT_FONT_FAMILY).toLowerCase(),
    fontStyle:
      shapeProps.isBold && shapeProps.isItalic
        ? 'italic bold'
        : shapeProps.isBold
          ? 'bold'
          : shapeProps.isItalic
            ? 'italic'
            : 'normal',
    fill: shapeProps.textColor || options?.defaultTextColor || '#B5B5B5',
    textDecoration: shapeProps.isUnderline ? 'underline' : 'none',
    align: shapeProps.textAlign || options?.defaultTextAlign || undefined
  };
};
